import { supabase } from '@/lib/supabase/supabaseClient';
import { MakeOptional, QuestionBank } from "../types";




export const addQuestionsToQuestionBank = async (args: Omit<MakeOptional<QuestionBank>, 'id' | 'created_at' | 'archived'>[]) => {
    return await supabase.from('question_bank').insert(args as QuestionBank[]).select();
}





export const downloadQuestionsTemplate = async (filePath: string = 'questions/question-template-1.xlsx') => {
    const res = await supabase
        .storage
        .from('templates')
        .download(filePath);
    return res
}
